"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddUserHoldingView = void 0;
class AddUserHoldingView {
    constructor(holdingRepository) {
        this.holdingRepository = holdingRepository;
    }
    execute(request) {
        return this.holdingRepository.addUserHoldingView(request);
    }
}
exports.AddUserHoldingView = AddUserHoldingView;
